import { useAuth } from "../store/AuthContext";
import { callApi } from "./apiHelper";

export const useApi = () => {
    const { logout } = useAuth();
  
    return async (url, options) => {
      return await callApi(url, options, logout);
    };
};
  

export const useHasPermission = () => {
  const { user } = useAuth();  
  return (permissionKey) => {
      if (!user) {
          return false;
      }
      if (user.Role === "SuperAdmin") {
          return true;
      }

      return user.Permission?.includes(permissionKey) ?? false;
  };
};

